import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {provideClientHydration} from '@angular/platform-browser';
import { APP_BASE_HREF, PlatformLocation } from '@angular/common';
import { provideHttpClient, withFetch } from '@angular/common/http';
export function getBaseHref(platformLocation: PlatformLocation): string {
  //console.log(platformLocation.href)
  return platformLocation.getBaseHrefFromDOM();
}
export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes), provideClientHydration() ,

provideHttpClient(withFetch()),
    {
      provide: APP_BASE_HREF,
      useFactory: getBaseHref,
      deps: [PlatformLocation],
    }


  ]
};
